import { TranslateCompiler } from '@ngx-translate/core';
import { environment } from '@environments/environment';

export class BrandTranslateCompiler extends TranslateCompiler {

  private readonly brandName: string = environment.brandName || 'Calenso';
  private readonly brandUrls: Record<string, string> = (environment as any).brandUrls || {};
  private readonly urlPattern = /(https?:\/\/[^\s<>"']+|mailto:[^\s<>"']+|[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,})/gi;

  compile(value: string, lang: string): string {
    if (typeof value !== 'string') {
      return value;
    }
    return this.processValue(value);
  }

  compileTranslations(translations: any, lang: string): any {
    return this.processObject(translations);
  }

  private processObject(obj: any): any {
    if (typeof obj === 'string') {
      return this.processValue(obj);
    }
    if (typeof obj === 'object' && obj !== null) {
      const result: any = Array.isArray(obj) ? [] : {};
      for (const key of Object.keys(obj)) {
        result[key] = this.processObject(obj[key]);
      }
      return result;
    }
    return obj;
  }

  private processValue(value: string): string {
    let result = this.replaceBrandUrls(value);

    if (this.brandName !== 'Calenso') {
      result = this.replaceBrandName(result);
    }

    return result;
  }

  private replaceBrandUrls(value: string): string {
    return value.replace(/%([A-Z_]+)%/g, (match, key) => {
      return this.brandUrls[key] || match;
    });
  }

  private replaceBrandName(value: string): string {
    const placeholders: string[] = [];

    const preserved = value.replace(this.urlPattern, (url) => {
      placeholders.push(url);
      return `__URL_PLACEHOLDER_${placeholders.length - 1}__`;
    });

    const replaced = preserved.replace(/calenso/gi, (match) => {
      if (match === 'CALENSO') return this.brandName.toUpperCase();
      if (match === 'calenso') return this.brandName.toLowerCase();
      return this.brandName;
    });

    return replaced.replace(/__URL_PLACEHOLDER_(\d+)__/g, (_, index) => placeholders[+index]);
  }
}
